import { useState } from "react"
import { Button, Flex, Form, Typography } from "antd"
import { InputOTP } from "antd-input-otp"

import { authStore } from "@src/app/authStore"
import css from "@src/app/components/ModalOtp/index.module.css"
import { catchErrors } from "@src/shared/api"

type Props = {
  isDisabled?: boolean
  onChange?: (value: string[]) => void
  onSubmit: (otp: string) => Promise<any>
  setVisible: (visible: boolean) => void
}
export const OTP_CODE_LEN = 6
export const FormOTP = ({
  isDisabled,
  onChange,
  onSubmit,
  setVisible,
}: Props) => {
  const { isOtpEnabled, merchant } = authStore
  const [value, setValue] = useState<string[]>([])
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const change = (e: string[]) => {
    setValue(e)
    setSubmitDisabled(e.length < OTP_CODE_LEN)
    if (onChange) {
      return onChange(value)
    }
  }

  const submit = ({ otp }: { otp: string[] }) => {
    setError(false)
    setSubmitDisabled(true)
    onSubmit(otp.join(""))
      .then((_) => setVisible(false))
      .catch((e) => {
        const errors = e.response?.data?.error?.errors
        if (!errors || !Array.isArray(errors)) {
          catchErrors(e)
          return setVisible(false)
        }

        const isOtp = (errors as Record<string, string>[]).some(
          (e) => e.target === "otp",
        )

        if (!isOtp) {
          catchErrors(e)
          return setVisible(false)
        }

        setError(isOtp)
      })
      .finally(() => setSubmitDisabled(false))
  }

  return (
    <Flex gap={32} vertical>
      {isOtpEnabled ? (
        <>
          <Typography.Paragraph
            style={{ fontSize: 16, margin: 0, textAlign: "center" }}
          >
            Enter the verification code from the app Google Authenticator{" "}
          </Typography.Paragraph>
          <Form
            className={css.otpForm}
            id="GENERATED_ID_FORMOTP_FORM_VOID_1"
            name="otpForm"
            onFinish={submit}
            size="large"
          >
            <Flex align="center" gap={32} vertical>
              <Form.Item id="GENERATED_ID_FORMOTP_FORM_ITEM_VOID_1" name="otp">
                <InputOTP
                  autoFocus
                  inputClassName={css.otpInput}
                  inputType="numeric"
                  onChange={change}
                  placeholder="0"
                  status={error ? "error" : ""}
                  value={value}
                />
              </Form.Item>
              <Form.Item
                id="GENERATED_ID_FORMOTP_FORM_ITEM_VOID_2"
                style={{ marginTop: 24 }}
              >
                <Button
                  disabled={isDisabled || submitDisabled}
                  htmlType="submit"
                  id="GENERATED_ID_FORMOTP_BUTTON_SUBMIT_1"
                  size="large"
                  type="primary"
                >
                  Submit
                </Button>
              </Form.Item>
            </Flex>
          </Form>
        </>
      ) : (
        <Typography.Paragraph style={{ textAlign: "center" }}>
          Please, enable OTP in settings
        </Typography.Paragraph>
      )}
    </Flex>
  )
}
